export type AppName = string;

angular.module('v6CoreModule').constant('appName', 'v6-core');
